import { Info, User, FileText, CalendarDays, Clock } from 'lucide-react'
import { Card, CardContent, CardHeader } from '#app/components/ui/card'

export default function ProcedureQuickInfo(props: {
	quickInfo: {
		purpose: string
		who_can_apply: string
		requirements: string[]
		deadlines: string
		duration: string
		additional_info: string
	}
}) {
	const { quickInfo } = props
	const quickInfoItems = [
		{ icon: Info, title: 'Objetivo', content: quickInfo.purpose },
		{
			icon: User,
			title: '¿Quién puede solicitarlo?',
			content: quickInfo.who_can_apply,
		},
		{
			icon: FileText,
			title: 'Requisitos principales',
			content: quickInfo.requirements,
		},
		{ icon: CalendarDays, title: 'Plazos', content: quickInfo.deadlines },
		{ icon: Clock, title: 'Duración del trámite', content: quickInfo.duration },
		{
			icon: FileText,
			title: 'Información adicional',
			content: quickInfo.additional_info,
		},
	].filter(item => item.content && item.content.length > 0)

	const iconClassName = 'mt-1 h-4 w-4 text-amber-500'
	return (
		<Card className="my-8 rounded-md bg-slate-50 shadow-lg">
			<CardHeader>
				<div className="prose">
					<h2>Información Rápida</h2>
				</div>
			</CardHeader>

			<CardContent className="grid gap-6 md:grid-cols-2">
				{quickInfoItems.map(({ icon: Icon, title, content }, index) => (
					<div key={index} className="space-y-2 overflow-hidden">
						<div className="flex items-start gap-2">
							<Icon className={iconClassName} />
							<div className="flex-1 overflow-hidden">
								<h3 className="font-semibold text-gray-900">{title}</h3>
								{Array.isArray(content) ? (
									<ul className="list-inside list-disc text-gray-700">
										{content.map((item, i) => (
											<li
												key={i}
												className="overflow-wrap-anywhere break-words"
											>
												{item}
											</li>
										))}
									</ul>
								) : (
									<p className="overflow-wrap-anywhere break-words text-gray-700">
										{content}
									</p>
								)}
							</div>
						</div>
					</div>
				))}
			</CardContent>
		</Card>
	)
}
